import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { components } from "../../utils/rt-mods";

export const DataCard = (props) => {
  const sc = props.slice.primary;

  const repeat = props.slice.items;

  let space = sc.spacing;

  if (space === "Both large") {
    space = "gutter";
  } else if (space === "Both small") {
    space = "gutter sm";
  } else if (space === "Top large") {
    space = "gutter bot";
  } else if (space === "Top small") {
    space = "gutter bot sm";
  } else if (space === "Bottom large") {
    space = "gutter top";
  } else {
    space = "gutter top sm";
  }

  return (
    <section className={"relative bg-" + sc.background + " " + space}>
      <div className="wrapper">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          {repeat.map((card, index) => {
            return (
              <div
                key={index}
                className="data-card w-full lg:w-1/3 relative flex flex-col justify-between"
              >
                <div>
                  <div className="icon w-12 h-16">
                    <img
                      className={card.data_color}
                      src={card.data_icon.url}
                      height={card.data_icon.dimensions.height}
                      width={card.data_icon.dimensions.width}
                      alt="Data icon"
                    />
                  </div>
                  <h3 className={"mb-3 text-" + card.data_color}>
                    {card.data_title.text}
                  </h3>
                  <PrismicRichText
                    field={card.data_description.richText}
                    components={components}
                  />
                </div>
                <div
                  className={
                    "rounded-lg flex h-36 px-10 items-center justify-center relative gap-4 bg-" +
                    card.data_color
                  }
                >
                  <div className="text-6xl font-bold text-white">
                    {card.data_point}
                  </div>
                  <div className="text-xl font-bold text-white">
                    {card.data_point_support}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
